module.exports = {"445302001":"云城街道","445302002":"高峰街道","445302003":"河口街道","445302004":"安塘街道","445302102":"腰古镇","445302103":"思劳镇","445302105":"前锋镇","445302106":"南盛镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445302.json
// module id = 2064
// module chunks = 0